<template>
    <div>
        <Card :bordered="false"
              :dis-hover="true">
            <p slot="title">{{item.name}}</p>

            <p><strong>Address:</strong> {{item.fullAddress ? item.fullAddress() : ''}}</p>

            <p><strong>Phone:</strong> {{item.phone}}</p>
        </Card>

        <Tabs value="employees">
            <TabPane label="Employees"
                     name="employees">
                <Table :columns="columns"
                       :data="data"
                       :loading="loading"/>

                <Page :total="pagination.total_objects"
                      :current="pagination.page"
                      :page-size="pagination.per_page"
                      @on-change="changePage"
                      @on-page-size-change="changePageSize"
                      show-total
                      :page-size-opts="[25, 50, 100]"
                      show-sizer/>
            </TabPane>

            <template slot="extra">
                <template>&nbsp;</template>

                <Button type="primary"
                        @click="create"
                        v-if="$store.getters.hasAccess('dictionary', 'create')">
                    <template>New</template>
                </Button>
            </template>

            <Modal v-model="modal"
                   :title="formTitle"
                   @on-ok="onOk"
                   @on-cancel="onCancel"
                   :loading="true"
                   ref="modal">
                <Form ref="form"
                      :model="form"
                      :rules="form.rules"
                      label-position="right"
                      :label-width="100">
                    <FormItem prop="first_name"
                              label="First Name">
                        <Input size="large"
                               v-model="form.first_name"
                               :autofocus="true"
                               type="text"
                               placeholder="First Name"/>
                    </FormItem>

                    <FormItem prop="last_name"
                              label="Last Name">
                        <Input size="large"
                               v-model="form.last_name"
                               type="text"
                               placeholder="Last Name"/>
                    </FormItem>

                    <FormItem prop="username"
                              label="Login">
                        <Input size="large"
                               v-model="form.username"
                               type="text"
                               placeholder="Login"/>
                    </FormItem>

                    <FormItem prop="email"
                              label="Email">
                        <Input size="large"
                               v-model="form.email"
                               type="text"
                               placeholder="Email"/>
                    </FormItem>

                    <FormItem prop="password"
                              label="Password">
                        <Input size="large"
                               v-model="form.password"
                               type="password"
                               password
                               placeholder="Password"/>
                    </FormItem>
                </Form>
            </Modal>

            <ModifiedPermissions ref="modifiedPermissions"/>
        </Tabs>
    </div>
</template>

<script>
  import {Branch} from '../../../models/Branch'
  import {Employee} from '../../../models/Employee'
  import ModifiedPermissions from '../modals/permissions/modified'

  export default {
    components: {
      ModifiedPermissions,
    },

    data() {
      return {
        branch: {},
        modal: false,
        permission: false,
        form: {},
        loading: false,
        columns: [
          {title: 'Email', key: 'email'},
          {title: 'Login', key: 'username'},
          {
            title: 'Name',
            key: 'full_name',
            render: (h, params) => {
              return h('div', new Employee().fullName(params.right));
            }
          },
          {
            title: 'Actions',
            width: 220,
            key: 'actions',
            render: (h, params) => h('div', {style: {textAlign: 'right'}}, [...this.columnActions(h, params)]),
          }
        ],
        pagination: {
          total_objects: 0,
          per_page: 25,
          page: 1
        },
        data: [],
        item: {},
      }
    },

    computed: {
      formTitle() {
        return this.form.id ? 'Edit Employee' : 'Create Employee'
      }
    },

    created() {
      this.reload()
    },

    methods: {
      columnActions(h, params) {
        let actions = [];

        if (this.$store.getters.hasAccess('admin', 'admin')) {
          actions.push(h('Button', {
              props: {type: 'default', size: 'small'},
              style: {marginRight: '5px'},
              on: {
                click: () => this.permissions(params.index)
              }
            }, 'Permissions'),
          )
        }

        if (this.show) {
          actions.push(h('Button', {
              props: {type: 'default', size: 'small'},
              style: {marginRight: '5px'},
              on: {
                click: () => this.show(params.index)
              }
            }, 'View'),
          )
        }

        if (this.$store.getters.hasAccess('dictionary', 'update')) {
          actions.push(h('Button', {
            props: {type: 'primary', size: 'small'},
            style: {marginRight: '5px'},
            on: {
              click: () => this.edit(params.index)
            }
          }, 'Edit'))
        }

        if (this.$store.getters.hasAccess('dictionary', 'delete')) {
          actions.push(h('Poptip', {
            props: {
              confirm: true,
              title: 'Are you sure you want to delete this item?',
              placement: 'left',
              transfer: true,
            },
            on: {
              'on-ok': () => this.remove(params.index)
            }
          }, [h('Button', {
            props: {
              type: 'error',
              size: 'small'
            },
            style: {
              marginRight: '5px'
            },
          }, 'Delete')]));
        }
        return actions
      },

      permissions(index) {
        this.$refs.modifiedPermissions.open(this.data[index])
      },

      onChange(id) {
        let filtered = this.branchList.filter(item => item.id === id);
        this.form.branch = filtered.length ? filtered[0] : null
      },

      onOk() {
        this.form
          .save()
          .then(resp => {
            this.modal = false;
            this.reload()
          })
          .catch(err => {
            console.error(err);
            this.$refs['form'].validate();
            this.$refs['modal'].buttonLoading = false
          })
      },

      onCancel() {
      },

      create() {
        this.form = new Employee();
        this.form.branch = this.item;
        this.modal = true
      },

      edit(index) {
        this.form = this.data[index].clone();
        this.modal = true
      },

      remove(index) {
        this.data[index]
          .delete()
          .then(resp => {
            this.reload()
          })
          .catch(err => {
            this.reload()
          })
      },

      reload() {
        this.loading = true;
        new Branch().with(['employees.branch', 'employees.accesses']).find(this.$route.params.id)
          .then(resp => {
            this.item = resp;
            this.data = resp.employees.data || [];
            this.loading = false
          })
          .catch(err => {
            console.log(err);
            this.loading = false
          });
      },

      changePage(page) {
        this.pagination.page = page;
        this.reload()
      },

      changePageSize(per_page) {
        this.pagination.per_page = per_page;
        this.reload()
      },
    }
  }
</script>